/**
 * Enum for Order Delivery Types
 */
export enum OrderDeliveryType {
	Delivery = "delivery",
	Pick_Up = "pick-up",
	Eat_Inside = "eat-inside"
}
